import { DocItem } from '@epam/uui-docs';

export const ThemingOverviewDocItem: DocItem = {
    id: 'themingOverview',
    name: 'Theming Overview',
    parentId: 'themes',
    examples: [
        { descriptionPath: 'theming-intro' },
    ],
};
